/* eslint-disable no-console */

const DevTools = {
  debug: false,
  enableDebug (): void {
    this.debug = true;
    console.warn("Development debug flag is set to: ", this.debug);
  },
  disableDebug (): void {
    this.debug = false;
    console.warn("Development debug flag is set to: ", this.debug);
  },
};

export default DevTools;
